import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import Loader from "../../../Components/Loader";
import {
    createAPIEndpointSurveyFeedback,
    EndpointSurveyFeedback,
} from "../../../Services/SurveyFeedback/SurveyFeedbackService";
import storage from "../../../Services/Storage";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";

const SurveyFeedbackView = () => {
    const nav = useNavigate();
    const auth = storage.getLocal("user");
    const [searchParam] = useSearchParams();
    const surveyId = searchParam.get("surveyid");

    const [loading, setLoading] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);

    /* ================= BUILD UI STRUCTURE ================= */

    const buildSurveyForUI = (data) => {
        return data.questions.map((q) => ({
            id: q.questioN_ID,
            text: q.questioN_TEXT,
            type: q.questioN_TYPE, // RADIO | CHECKBOX
            isRequired: q.iS_REQUIRED === "Y",
            options: data.options
                .filter((o) => o.questioN_ID === q.questioN_ID)
                .sort((a, b) => a.seQ_NO - b.seQ_NO)
                .map((o) => ({
                    id: o.optioN_ID,
                    text: o.optioN_TEXT,
                })),
        }));
    };

    /* ================= LOAD SURVEY ================= */

    const LoadSurveryDeatilsByID = async () => {
        setLoading(true);
        try {
            const res = await createAPIEndpointSurveyFeedback().get(
                `${EndpointSurveyFeedback.LoadSurveryDeatilsByID}?Survey_id=${surveyId}`
            );

            const apiData = JSON.parse(res.data[0].DATA);
            console.log(JSON.parse(res.data[0].DATA), "SUBMIT PAYLOAD:");
            const uiQuestions = buildSurveyForUI(apiData);
            setQuestions(uiQuestions);
        } catch (ex) {
            console.error(ex);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        LoadSurveryDeatilsByID();
    }, []);

    /* ================= ANSWER HANDLERS ================= */

    // RADIO (single select)
    const handleRadioChange = (questionId, optionId) => {
        setAnswers((prev) => {
            const filtered = prev.filter((a) => a.questionId !== questionId);
            return [...filtered, { questionId, optionIds: [optionId] }];
        });
    };

    // CHECKBOX (multi select)
    const handleCheckboxChange = (questionId, optionId, checked) => {
        setAnswers((prev) => {
            const existing = prev.find((a) => a.questionId === questionId);
            let optionIds = existing?.optionIds || [];

            optionIds = checked
                ? [...optionIds, optionId]
                : optionIds.filter((id) => id !== optionId);

            return [
                ...prev.filter((a) => a.questionId !== questionId),
                { questionId, optionIds },
            ];
        });
    };

    /* ================= VALIDATION ================= */

    const validateAnswers = () => {
        for (const q of questions) {
            if (!q.isRequired) continue;

            const ans = answers.find((a) => a.questionId === q.id);
            if (!ans || !ans.optionIds || ans.optionIds.length === 0) {
                return false;
            }
        }
        return true;
    };

    /* ================= BUILD SAVE PAYLOAD ================= */

    const buildAnswerPayload = () => {
        const flatAnswers = [];

        answers.forEach((a) => {
            a.optionIds.forEach((optId) => {
                flatAnswers.push({
                    QUESTION_ID: a.questionId,
                    OPTION_ID: optId,
                });
            });
        });

        return {
            SURVEY_ID: surveyId,
            USER_ID: auth.UserId,
            COMP_ID: auth.CompId,
            Answers: flatAnswers,
        };
    };

    /* ================= SUBMIT ================= */

    const submitFeedback = async () => {
        if (!validateAnswers()) {
            toast.warn("Please answer all required questions", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }

        const payload = buildAnswerPayload();
        console.log("SUBMIT PAYLOAD:", payload);

        try {
            const res = await createAPIEndpointSurveyFeedback().post(
                EndpointSurveyFeedback.SaveFeedbackAnsDeails,
                payload
            );
            console.log(res.data,"submitFeedback");
            toast.success(res.data, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            nav("/helpdesk/surveyfeedback");
        } catch (ex) {
            console.error(ex);
            toast.error("Error Occurred", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
    };

    /* ================= UI ================= */

    if (loading) return <Loader />;

    return (
        <div className="col-12 pt-0 pb-4">
            <div className="row">
                <div className="col-lg-6">
                    <nav>
                        <ol className="breadcrumb mx-1">
                            <li className="breadcrumb-item">
                                <Link to="/helpdesk/surveyfeedback">Survey Feedback</Link>
                            </li>
                            <li className="breadcrumb-item active">View</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="float-end">
                        <Link to="/helpdesk/surveyfeedback">
                            <button type="button" className="btn btn-primary">
                                <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                                Records
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

            <section className="Survey_Form_Panel">
                <div className="col-lg-12">
                    {questions.map((q, index) => (
                        <div className="Box mb-4" key={q.id}>
                            <h4 className="mb-2">
                                {index + 1}. {q.text}
                                {q.isRequired && <span className="text-danger"> *</span>}
                            </h4>

                            {q.type === "RADIO" &&
                q.options.map((o) => (
                    <div className="mb-2" key={o.id}>
                        <RadioButton
                            inputId={o.id}
                            name={q.id}
                            onChange={() => handleRadioChange(q.id, o.id)}
                            checked={
                                answers.find((a) => a.questionId === q.id)
                                    ?.optionIds?.[0] === o.id
                            }
                        />
                        <label className="ms-2">{o.text}</label>
                    </div>
                ))}

                            {q.type === "CHECKBOX" &&
                q.options.map((o) => (
                    <div className="mb-2" key={o.id}>
                        <Checkbox
                            inputId={o.id}
                            onChange={(e) =>
                                handleCheckboxChange(q.id, o.id, e.checked)
                            }
                            checked={
                                answers
                                    .find((a) => a.questionId === q.id)
                                    ?.optionIds?.includes(o.id) || false
                            }
                        />
                        <label className="ms-2">{o.text}</label>
                    </div>
                ))}
                        </div>
                    ))}

                    <button className="btn btn-primary" onClick={submitFeedback}>
            Submit Feedback
                    </button>
                </div>
            </section>
        </div>
    );
};

export default SurveyFeedbackView;
